import Model from 'utils/Model';
import validators from 'utils/validators';
import { composeValidators } from 'utils/validators/compose';
import UserModel from '../users/models/UserModel';

class CommentVersionModel extends Model {
    static validators = {
        text: composeValidators(validators.required),
    };

    initialize(props) {
        super.initialize(props);
        this.id = props.id;

        this.text = props.text || '';
        this.user = new UserModel(props.user);
    }
}

export default CommentVersionModel;
